module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-fi.73c76f8b1c9ae2d00fdb.svg";